(function () {
    'use strict';

    angular
        .module('app')
        .factory('folderBrowserService', folderBrowserService);

    folderBrowserService.$inject = ['$timeout', '$http', '$q', 'clientService'];

    function folderBrowserService($timeout, $http, $q, clientService) {
        var service = {
            show: show,
            close: close,
            cancel: cancel,
            getDrives: getDrives,
            getDirectories: getDirectories,
            renameDirectory: renameDirectory,
            createDirectory: createDirectory,
            deleteDirectory: deleteDirectory,
            verifyDirectory: verifyDirectory,
            path: "",
            shown: false,
        };
        var deferred;

        return service;
        

        function show(path) {
            deferred = $q.defer();
            service.path = path;
            service.shown = true;
            return deferred.promise;
        }

        function close(path) {
            service.shown = false;
            deferred.resolve(path);
        }

        function cancel() {
            service.shown = false;
            deferred.resolve(null);
        }

        function getDrives() {
            var deferred = $q.defer();
            clientService.get('filesystem/drives').then(function (response) {
                service.users = response;
                var data = [];
                angular.forEach(response, function (item, index) {
                    data.push({
                        id: item._name.substring(0,2).toUpperCase(),
                        parent: '#',
                        text: item._name,
                        state: { opened: false },
                        children: true,
                        data: item._name,
                        type: 1,
                    });
                });

                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getDirectories(path) {
            var deferred = $q.defer();
            clientService.get('filesystem/directories?path=' + encodeURI(path)).then(function (response) {
                var data = [];
                angular.forEach(response, function (item, index) {
                    data.push({
                        id: item.Path.toUpperCase(),
                        text: item.Name,
                        state: { opened: false },
                        children: item.Children,
                        data: item.Path,
                        type: 2,
                        unc: item.UNC
                    });
                });
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createDirectory(path) {
            var deferred = $q.defer();
            clientService.post('filesystem/directory?path=' + encodeURI(path)).then(function (response) {
                service.users = response;
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        function renameDirectory(path, newPath) {
            var deferred = $q.defer();
            clientService.put('filesystem/directory?path=' + encodeURI(path) + "&newPath=" + encodeURI(newPath)).then(function (response) {
                service.users = response;
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function deleteDirectory(path) {
            var deferred = $q.defer();
            clientService.delete('filesystem/directory?path=' + encodeURI(path)).then(function (response) {
                service.users = response;
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        function verifyDirectory(path) {
            var deferred = $q.defer();
            clientService.get('filesystem/VerifyDirectory?path=' + encodeURI(path)).then(function (response) {
                service.users = response;
                deferred.resolve(response);
            });
            return deferred.promise;
        }





    }
})();